
import { DefaultToast } from "components/toast";
import {LoaderScreen} from "pages/loaderscreen";
import { PageLoaderContextProvider } from "provider";
import React, { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { initInterceptors, MetaTags } from "utils";

const LazyLoadedAppComponent = lazy(() => import("./routes/webRoutes"));
const App = () => {
  React.useEffect(() => {
    console.log("app component frame refreshes on load");
    initInterceptors();
  }, []);
  return (
    <HelmetProvider>
      <MetaTags/>
      <PageLoaderContextProvider>
        <Suspense fallback={<LoaderScreen />}>
          <DefaultToast />
          <div className="app">
            <LazyLoadedAppComponent />
          </div>
        </Suspense>
      </PageLoaderContextProvider>
    </HelmetProvider>
  );
};

export default App;
